import React from 'react';
import { Form } from 'antd';
import CustomerTextInput from '../../inputs/customerTextInput/CustomerTextInput';
import CustomerSelectInput from '../../inputs/customerSelectInput/CustomerSelectInput';
import CustomerVerificationInput from '../../inputs/customerVerificationInput/CustomerVerificationInput';
import DefaultButton from '../../components/buttons/defaultButton/DefaultButton';
import useTranslation from '../../../hooks/translation/useTranslation';
import CustomerPhoneNumberInput from '../../inputs/customerPhoneInput/CustomerPhoneNumberInput';

function EditLegalProfile({
  handleSubmit, form, errors, options, setErrors,
}) {
  const { trans, currentLanguage, configInfo } = useTranslation();

  const isGeorgian = configInfo?.countryCode === 'GE';

  return (
    <Form
      layout="vertical"
      onFinish={handleSubmit}
      form={form}
    >
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerSelectInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          options={options?.countries?.map((country) => ({
            value: country.id,
            label: country[`name_${currentLanguage === 'am' ? 'ka' : currentLanguage}`] || country.name_ka,
          }))}
          className="basis-1/2 white-background"
          name="country"
          label={trans('country')}
          errorMessage={errors?.country}
        />
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="flex-1"
          name="identification_number"
          label={trans('identification_number')}
          required
          errorMessage={errors?.identification_number}
        />
      </div>
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerSelectInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          options={options?.organization_types?.map((organization) => ({
            value: organization.id,
            label: organization[`name_${currentLanguage === 'am' ? 'ka' : currentLanguage}`] || organization.name_ka,
          }))}
          className="basis-1/2 white-background"
          name="organization_type_id"
          label={trans('organization_type')}
          errorMessage={errors?.organization_type_id}
        />
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="flex-1"
          name="organization_name"
          label={trans('organization_name')}
          required
          errorMessage={errors?.organization_name}
        />
      </div>
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="basis-1/2"
          name="bank_account_number"
          label={trans('bank_account_number')}
          required
          errorMessage={errors?.bank_account_number}
        />
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="flex-1"
          name="legal_address"
          label={trans('legal_address')}
          required
        />
      </div>
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerPhoneNumberInput
          options={options?.countries?.map((country) => ({
            label: country.country_phone_code,
            value: country.country_phone_code,
          }))}
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className={`${isGeorgian ? 'basis-1/2' : 'basis-full'} white-background`}
          name="phone_number"
          label={trans('phone_number')}
          selectName="country_phone_code"
          required
          codeSelectDisabled
          errorMessage={errors?.country_phone_code || errors?.phone_number}
        />
        {isGeorgian && (
        <CustomerVerificationInput
          className="basis-1/2 -mt-9 lg:mt-0"
          name="verified_phone"
          label="ნომერი"
          errors={errors}
          setErrors={setErrors}
          form={form}
          verifyType={2}
        />
        )}
      </div>
      <div className="flex gap-1 flex-col lg:flex-row lg:gap-4">
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="basis-1/2"
          name="email"
          label={trans('email')}
          required
          errorMessage={errors?.email}
          disabled
        />
        <CustomerVerificationInput
          className="basis-1/2 -mt-9 lg:mt-0"
          name="verified_email"
          label="ნომერი"
          errors={errors}
          setErrors={setErrors}
          form={form}
          verifyType={1}
        />
      </div>
      <div className="flex">
        <DefaultButton className="flex-1 !p-0 h-[60px] mt-auto mb-6" type="submit">{trans('finish')}</DefaultButton>
      </div>
    </Form>
  );
}

export default EditLegalProfile;
